import { render, staticRenderFns } from "./IntegrationGame.vue?vue&type=template&id=6ed4cc58&scoped=true&"
import script from "./IntegrationGame.vue?vue&type=script&lang=js&"
export * from "./IntegrationGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4cc58",
  null
  
)

export default component.exports